import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { f } from "../config";
import db from "../config";
import { GlobalContext } from "../Globalstate";
import "./Nav.css"; // ✅ new CSS file

function Nav() {
  const navigate = useNavigate();
  const [{ userdetails, loggedin }, dispatch] = useContext(GlobalContext);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loggedin) {
      setLoading(false);
    } else {
      f.auth().onAuthStateChanged((user) => {
        if (user) {
          const userId = user.uid;
          fetchUserData(userId);
          setLoggedIn(true);
        } else {
          setLoggedIn(false);
          setLoading(false);
          navigate("/");
        }
      });
    }
  }, []);

  const fetchUserData = async (userId) => {
    try {
      const docRef = db.collection("users").doc(userId);
      const doc = await docRef.get();
      if (doc.exists) {
        setDetails(doc.data());
      }
      setLoading(false);
    } catch (err) {
      console.error("Error fetching user:", err);
      setLoading(false);
    }
  };

  const setDetails = (data) => dispatch({ type: "setuserdetails", snippet: data });
  const setLoggedIn = (status) => dispatch({ type: "setloggedin", snippet: status });

  const logout = async () => {
    setLoggedIn(false);
    await f.auth().signOut();
    navigate("/");
  };

  return (
    <nav className="navContainer">
      <div className="navLogo">
        <a href="/dashboard">
          <img src="/logo192.png" alt="Home" />
        </a>
      </div>

      <div className="navMenu">
        <a href="/dashboard" className="navItem active">
          <i className="icon-home2" />
          <span>Dashboard</span>
        </a>
        <a href="/deposit" className="navItem">
          <i className="icon-attach_money" />
          <span>Finance</span>
        </a>
        <a href="/DepositHistory" className="navItem">
          <i className="icon-clock1" />
          <span>Account History</span>
        </a>
        <a href="/Profile" className="navItem">
          <i className="icon-settings1" />
          <span>Settings</span>
        </a>
        <button className="navItem logoutButton" onClick={logout}>
          <i className="icon-log-out1" />
          <span>Logout</span>
        </button>
      </div>

      <div className="navSubMenu">
        <ul>
          <li><a href="/deposit">Make a Deposit</a></li>
          <li><a href="/Withdrawal">Withdraw</a></li>
          <li><a href="/DepositHistory">Deposit History</a></li>
          <li><a href="/WithdrawalHistory">Withdrawal History</a></li>
          <li><a href="/ProfitsHistory">Earning History</a></li>
          <li><a href="/Profile">Edit Profile</a></li>
          <li><a href="/Refferals">Referrals</a></li>
          <li><a href="/realestate">Real Estate</a></li>
        </ul>
      </div>
    </nav>
  );
}

export default Nav;
